import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyDRTBIrctcwtx_RHNUxS1dCdUs6Pw1m8zM",
  authDomain: "newsappify.firebaseapp.com",
  projectId: "newsappify",
  storageBucket: "newsappify.firebasestorage.app",
  messagingSenderId: "473035114160",
  appId: "1:473035114160:web:95b9a7f28c7bd4feaddd75",
  measurementId: "G-EKDH433NPD"
};
  

// Prevent re-init during HMR
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

// Core services
const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)
const functions = getFunctions(app, 'us-central1')

// Analytics (browser-only, guards SSR/tests)
let analytics = null
if (typeof window !== 'undefined') {
  analyticsSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app)
  })
}

export { app, auth, db, storage, functions, analytics }